exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style__title___1lfdX{font-size:16px;font-weight:bold;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#778195}.style__description___2bLu4{font-size:14px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#778195;margin-top:10px}.style__content___1yiaA{border-top:1px solid;border-color:#e9e9e9;margin-top:17px;padding-top:11px;width:100%;flex:1;display:flex;flex-direction:column;overflow:hidden}\n", ""]);

// Exports
exports.locals = {
	"title": "style__title___1lfdX",
	"description": "style__description___2bLu4",
	"content": "style__content___1yiaA"
};